import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, adicionaIconesGrid, calculaAlturaGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-protocolo-tipo',
  templateUrl: './protocolo-tipo.component.html',
  styleUrls: ['./protocolo-tipo.component.css']
})
export class ProtocoloTipoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  editOptionsGridProtocoloTipo = {
    mode: GridConfig.gridMode, // form
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Protocolo Tipo',
      showTitle: true
    }
  };

  colunasGridProtocoloTipo = null;
  protocoloTipo = null;
  alturaGrid = null;

  constructor(@Inject(Http) http: Http) {
    this.protocoloTipo = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/protocolo-tipo/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/protocolo-tipo/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/protocolo-tipo/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/protocolo-tipo/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridProtocoloTipo = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'DescricaoProtocoloTipo',
        dataType: 'string',
        caption: 'Descrição do Protocolo Tipo',
        validationRules: [{
          type: 'required',
          message: 'Descrição do Protocolo Tipo é obrigatório.'
        }]
      }
    ];
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

}



// WEBPACK FOOTER //
// ./src/app/protocolo-tipo/protocolo-tipo.component.ts